/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Model from "App/model";
import {DataResource} from "App/storage/data_resource";

export
abstract class DataResourceObserver {
    private _dataResources: DataResource[] = [];

    protected constructor() {
    }

    public attachToDataResource(aResource: DataResource): void {
        this._dataResources.push(aResource);
    }

    public detachFromDataResource(aResource: DataResource): void {
        for (let i = 0; i < this._dataResources.length; i++) {
            if (this._dataResources[i].getUrl() === aResource.getUrl()) {
                this._dataResources.splice(i, 1);
                break;
            }
        }
    }

    public getAttachedDataResources(): DataResource[] {
        return this._dataResources;
    }

    abstract getAttachedBoundingBoxes();
    abstract dataDownloaded(aStatus: any, aResource: DataResource);
    abstract dataDownloadFailed(aStatus: any, aResource: DataResource);
    abstract dataDownloadAborted(aStatus: any, aResource: DataResource);
    abstract getLoadDataQuery(): any;
    abstract getModel(): Model;
}
